// @flow

import React, { PureComponent } from 'react';
import { css, cx } from 'emotion';
import Dropdown, { type DropdownProps } from '../Dropdown';
import customComponents from './customComponents';
import Colors from '../../../../../styles/Colors';

const styles = {
  dropdownContainer: css({
    maxWidth: '200px',
    minWidth: '125px',
    marginBottom: '25px'
  })
};

const customStyles = {
  control: providedStyling => ({
    ...providedStyling,
    boxSizing: 'border-box',
    border: `1px solid ${Colors['@gallery']}`,
    borderRadius: '8px',
    backgroundColor: Colors['@white']
  }),
  singleValue: providedStyling => ({
    ...providedStyling,
    paddingLeft: '6px'
  })
};

class DeviceDropdown extends PureComponent<DropdownProps> {
  render() {
    const { testid, outerClassName, ...dropdownProps } = this.props;
    return (
      <Dropdown
        {...dropdownProps}
        testid={`${testid}__device-dropdown`}
        outerClassName={cx(styles.dropdownContainer, outerClassName)}
        styles={customStyles}
        components={customComponents}
      />
    );
  }
}

export default DeviceDropdown;
